import router from '@/router'
import store from '@/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // 浏览器进度条
import 'nprogress/nprogress.css'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/signature', '/branchCode', '/mccCode', '/areaCode'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // 进度条start
  NProgress.start()
  // 设置title
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`))

  // 是否已登录
  const hasLogin = localStorage.getItem('ZZGAgentUser')

  if (hasLogin) {
    // 将localstorage中的数据存入store，方便读取
    if (JSON.stringify(store.state.user.userInfo) === '{}') {
      const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser'))
      console.log('已经登录的数据=====', JSON.stringify(userInfo))
      store.dispatch('user/setUserInfo', userInfo)
    }
    if (to.path === '/login') {
      next({ path: '/index/index' })
      NProgress.done()
    } else {
      const hasRoutes = store.state.permission.addRoutes && store.state.permission.addRoutes.length > 0
      if (hasRoutes) {
        next()
      } else {
        try {
          const accessRoutes = await store.dispatch('permission/generateRoutes', '')
          if (accessRoutes && accessRoutes.length > 0) {
            router.options.routes = accessRoutes
            router.addRoutes(accessRoutes)
            next({ ...to, replace: true })
          } else {
            // 没获取到权限信息,清除全部缓存重新登陆
            store.dispatch('permission/clearRoutes')
            store.dispatch('user/logout')
            next('/login')
            NProgress.done()
          }
        } catch (error) {
          Message.error(error || 'Has Error')
          // 没获取到权限信息,清除全部缓存重新登陆
          store.dispatch('permission/clearRoutes')
          store.dispatch('user/logout')
          next('/login')
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      store.dispatch('permission/clearRoutes')
      store.dispatch('user/logout')
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // 进度条finish
  NProgress.done()
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    // router.replace(targetPath)
    location.reload(targetPath)
  }
})
